import { gql } from '@apollo/client';

export const SET_CB_SETTING = gql`
  mutation SetCbSetting($input: SetCbSettingInput!) {
    setCbSetting(input: $input) {
      __typename
      id
      type
      agencyId
      campaignType
      ... on CbInviteProcessingFeeSetting {
        inviteProcessingFee
      }
      ... on CbProcessingFeeSetting {
        launchFee
      }
      ... on CbFeeSetting {
        launchFee
      }
      ... on CbPitchSetting {
        pitch
        isRequired
      }
      ... on CbLockSetting {
        durationSeconds
      }
      ... on CbDeliverableRevisionLimitSetting {
        revisionLimit
      }
      ... on CbDigitalAgreementSetting {
        enabled
      }
      ... on CbAgencySignUpEmailVerificationSetting {
        enabled
      }
    }
  }
`;
